export default "__VITE_ASSET__2010f236__"